import { useCallback } from 'react'
import { useSelector } from '@/libs/state'
import { getPermissionConfig } from '../application/get-permission-config'
import { DEFAULT_PERMISSION_CONFIG } from '../domain/permission'
import { draftRoleConfigs$, draftUserOverrides$, permissionConfig$ } from '../store'
import { notify, permissions as permissionsPort } from '../wiring'

const usePermissionConfig = () => {
	const config = useSelector(permissionConfig$)

	const reload = useCallback(async () => {
		const result = await getPermissionConfig(permissionsPort, notify)
		const resolved = result ?? DEFAULT_PERMISSION_CONFIG
		permissionConfig$.set(resolved)
		draftRoleConfigs$.set(resolved.roleConfigs)
		draftUserOverrides$.set(resolved.userOverrides)
	}, [])

	return { config, reload }
}

export { usePermissionConfig }
